import { Heading, Img } from "./..";
import React from "react";

export default function MachinePerformanceOverview({
  trophyImage = "images/img_trophy.svg",
  performanceHeading = "Machine performance",
  sensorDataText = "Plug in existing and new sensor data. ",
  monitoringText = "Monitor and predict machine performance with condition-based monitoring.",
  maintenanceText = "Schedule preventive maintenance and prevent costly failures.",
  ...props
}) {
  return (
    <div {...props} className={`${props.className} flex flex-col gap-6`}>
      <Img src={trophyImage} alt="Trophy Image" className="h-[64px] w-[22%] object-contain sm:w-auto" />
      <div className="flex flex-col items-start gap-6 self-stretch w-full">
        <Heading
          size="heading9xl"
          as="h4"
          className="text-[26px] font-bold leading-[130%] tracking-[-0.54px] text-white md:text-[24px]"
        >
          {performanceHeading}
        </Heading>
        <div className="flex flex-col gap-6 w-full">
          <Heading
            size="text6xl"
            as="p"
            className="text-[19px] font-light leading-[130%] tracking-[-0.38px] text-colors sm:text-[18px]"
          >
            {sensorDataText}
          </Heading>
          <Heading
            size="text6xl"
            as="p"
            className="text-[19px] font-light leading-[130%] tracking-[-0.38px] text-white sm:text-[18px]"
          >
            {monitoringText}
          </Heading>
          <Heading
            size="text6xl"
            as="p"
            className="text-[19px] font-light leading-[130%] tracking-[-0.38px] text-white sm:text-[18px]"
          >
            {maintenanceText}
          </Heading>
        </div>
      </div>
    </div>
  );
}
